import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateFields } from '../ReduxImpl/actions/index'

import SitecoreJssForm from '../SitecoreJssForm/index'

const JssFormDisplay = ({ fields, history: _, isContact }) => {
  const dispatch = useDispatch()

  const fieldsData = useSelector((state: any) => state.fields)

  const JssFormKey = useSelector((state: any) => state.JssFormKey)

  useEffect(() => {
    dispatch(updateFields(fields))
  }, [fields])

  return (
    <div key={JssFormKey}>
      <SitecoreJssForm fields={fieldsData} isContact={isContact} />
    </div>
  )
}

export default JssFormDisplay
